import QROnly from "./QROnly";

export default QROnly;